/**
 * An AMD wrapper around bootstrap ui for loaders (like DOJO) that don't
 * support shims
 *
 * TODO: do a bootstrap layer
 */
define(['text!bootstrap/js/tooltip.js', 'text!bootstrap/js/popover.js','jquery'], function(sc2,sc3){
	(new Function(sc2))();
	(new Function(sc3))();
	return;
});
